import React from "react";

export const ArrowSVGComponent = () => (
    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M1 5.11768H14.7641H1Z" fill="white" />
        <path d="M1 5.11768H14.7641" stroke="#242E35" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M21 15.7051H7.23593H21Z" fill="white" />
        <path d="M21 15.7051H7.23593" stroke="#242E35" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.117 9.23492V1L20.9991 5.11746L15.117 9.23492Z"
            fill="white"
            stroke="#242E35"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.88208 11.5879V19.8228L1 15.7053L6.88208 11.5879Z"
            fill="white"
            stroke="#242E35"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
